import React from 'react';
import { childrenPropTypes } from '../../utils/propTypesUtils';
import { useSSRQuery } from '../useSSRQuery';
import GET_SEATSIZESMAP_QUERY from '../components/seatSizesMapProvider/getSeatSizesMap.query.graphql';
import { useCart } from './CartProvider';

export const SeatSizesMapData = React.createContext({});
export const useSeatSizesMap = () => React.useContext(SeatSizesMapData);

const SeatSizesMapProvider = ({ children }) => {
  const { cart } = useCart();
  const { loading, error, data, refetch } = useSSRQuery(
    GET_SEATSIZESMAP_QUERY,
    {
      fetchPolicy: 'network-only',
      skip: !cart, // skip if cart is not present
    }
  );
  return (
    <SeatSizesMapData.Provider
      value={{
        seatSizesMap: data,
        seatSizesMapError: error,
        seatSizesMapLoading: loading,
        updateSeatSizesMap: refetch,
      }}
    >
      {children}
    </SeatSizesMapData.Provider>
  );
};
SeatSizesMapProvider.propTypes = childrenPropTypes;
export default SeatSizesMapProvider;
